module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-hint"
  }, [_c('div', {
    staticClass: "hint-title"
  }, [_vm._v("Password must contain:")]), _vm._v(" "), _c('div', {
    staticClass: "hint-criteria"
  }, _vm._l((_vm.criteria), function(criterion) {
    return _c('div', {
      key: criterion.id,
      staticClass: "criterion",
      class: {
        'matched': criterion.matched
      }
    }, [_c('span', {
      staticClass: "criterion-icon"
    }, [_c('i', {
      class: criterion.matched ? 'icon-check' : 'icon-close'
    })]), _vm._v(" "), _c('span', {
      staticClass: "criterion-text"
    }, [_vm._v(_vm._s(criterion.text))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-475f14a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordHint.vue
// module id = 2144
// module chunks = 1